import messages from './ProductType.messages';
import { IwDynamicFormattedMessage } from '../../../iwDynamicFormattedMessage/IwDynamicFormattedMessage';
import { FormattedMessage } from 'react-intl';

const ProductType = ({
    productType,
    isDynamic,
    durationInMonths
}: {
    productType: string;
    isDynamic?: boolean;
    durationInMonths?: number;
}) => {
    if (durationInMonths && durationInMonths > 12) {
        return (
            <FormattedMessage
                {...messages.longer_credit_facility}
                values={{
                    duration: durationInMonths
                }}
            />
        );
    }

    if (isDynamic) {
        return (
            <IwDynamicFormattedMessage
                messages={messages}
                messageKey={'credit_facility_label_dynamic'}
                defaultMessage=""
            />
        );
    } else
        return (
            <IwDynamicFormattedMessage
                messages={messages}
                messageKey={`${productType}_label`}
                defaultMessage=""
            />
        );
};

// eslint-disable-next-line import/no-default-export
export default ProductType;
